import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import rcmlogo from '../../assets/images/rcmlogo.png';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useAppDispatch } from "../../core/redux/hooks";
import { showToaster } from '../../core/redux/toastSlice';

const ResetPassword = () => {

    const [email, setEmail] = useState("");
    const [disable, setDisable] = useState(false);
    const dispatch = useAppDispatch();
    const apiBases = process.env.REACT_APP_API_URL;

    const handleSubmit = (e: any) => {
        e.preventDefault();
        setDisable(true);
        if (!email) {
            setDisable(false);
            dispatch(showToaster(
                {
                    dialogBgColor: 'bg-danger',
                    dialogMsg: "Email is required",
                    showDialog: true,
                    timer: '5000'
                }
            ));
        } else {
            const postdata = {
                email: email?.toLowerCase().trim()
            }
            axios.post(apiBases + '/admin/auth/reset_password', postdata)
                .then((res) => {
                    if (res.data.status === "Success") {
                        dispatch(showToaster(
                            {
                                dialogBgColor: 'bg-success',
                                dialogMsg: res.data.data,
                                showDialog: true,
                                timer: '5000'
                            }
                        ));
                    }
                    setDisable(false);
                }).catch((err) => {
                    console.log(err.response.data.message);
                    dispatch(showToaster(
                        {
                            dialogBgColor: 'bg-danger',
                            dialogMsg: err.response.data.message ? err.response.data.message : 'Somthing went wrong!',
                            showDialog: true,
                            timer: '5000'
                        }
                    ));
                    setDisable(false);
                })
        }
    }

    return (
        <>
            <div className="resetcard">
                <Card className="" >
                    <Card.Img src={rcmlogo} alt="Card image" className="rcmlogo" />

                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <div className="m-3">
                                <div className='mb-2'>
                                    <label><b>Enter Your Email Here</b> </label>
                                </div>
                                <div>
                                    <input type="text" name="email" onChange={(e) => { setEmail(e.target.value); }} className="form-control input-textgenere" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="text-center" >
                                    <Button type="submit" style={{ backgroundColor: '#0187c4' }} disabled={disable} onClick={handleSubmit} className="m-3">
                                        {
                                            disable && <div className="spinner-border spinner-border-sm me-2" role="status">  <span className="sr-only">Loading...</span></div>
                                        }
                                        Submit
                                    </Button>
                                    <Link to="/sign-in"><Button disabled={disable} className="btn btn-secondary">Cancel</Button></Link>
                                </div>
                            </div>
                        </Form>

                    </Card.Body>
                </Card>
            </div>
        </>

    )
}

export default ResetPassword;